import React from 'react';
import { PropTypes } from 'prop-types';
import ModalWrapper from 'components/Modals/ModalWrapper';

const UnassignToUserModal = ({
  isShown,
  onCancel,
  onConfirmUnassign,
  form,
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title="Unassign Form"
    btnConfirmTitle="Unassign"
    btnCancelTitle="Cancel"
    onConfirm={ () => onConfirmUnassign(form) }
    onCancel={ onCancel }
  >
    <p>
      Are you sure you want to unassign this form?
    </p>
  </ModalWrapper>
);

UnassignToUserModal.propTypes = {
  isShown: PropTypes.bool,
  onConfirmUnassign: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.arrayOf(PropTypes.shape({}))
};

UnassignToUserModal.defaultProps = {
  isShown: false,
  form: []
};

export default UnassignToUserModal;
